import { ServerCartResponse } from "@/redux/slice/cart/types/ServerCartResponse";
import { ServerCartItems } from "@/redux/slice/cart/types/ServerCartItems";
import {
  updateAddressLoading,
  updateCurrentAddressId,
  updateIsAddressUpdated,
  updatePickAddressDialogOpen,
  updateSpecifiedLocation,
} from "@/redux/slice/location/slice";

import { setServerCartErrorMessage, setCartLocation, appendOutOfStockSkus, setCartTotalAmount } from "@/redux/slice/cart/slice";
import { CartItem } from "@/redux/slice/cart/types/CartItem";
import { getPatientCartItemsFromServer } from "@/redux/slice/cart/utils/getPatientCartItemsFromServer";
import { updateCurrentPatientId } from "@/redux/slice/auth/slice";
import { replaceCartItems } from "@/redux/slice/cart/utils/replaceCartItems";

export const handleServerCartResponse = async (serverCartResponse: ServerCartResponse, dispatch): Promise<void> => {
  const syncDeviceCart = (serverCartItems: CartItem[]): void => {
    try {
      // replace the cart items with the ones that were recieved from save cart
      replaceCartItems(serverCartItems, dispatch);
    } catch (syncCartError) {
      console.error("Failed to sync device cart", syncCartError);
    }
  };

  const cartNotification = serverCartResponse?.message?.value || "";
  const showAtCartNotification = serverCartResponse?.message?.showOnlyAtCart;
  // below block is for events and notification for cart page

  if (cartNotification?.length) {
    if (!showAtCartNotification) dispatch(setServerCartErrorMessage(cartNotification));
    // why update address loading here?
    dispatch(updateAddressLoading(false));
  }

  const data = serverCartResponse?.data;

  if (!data) {
    return;
  }
  const cartFeedback = serverCartResponse?.message?.feedback;
  const patientAddressId = data?.address?.id;
  const currentPatientId = data?.patientId;
  const latitude = data?.address?.coordinate?.latitude?.toString() || "";
  const longitude = data?.address?.coordinate?.longitude?.toString() || "";
  const pincode = data?.address?.zipcode || "";
  const city = data?.address?.city || "";
  const state = data?.address?.state || "";

  const serverCartItems: ServerCartItems = data?.medicineOrderCartLineItems;

  // map function
  const deviceCartItems = getPatientCartItemsFromServer(serverCartItems);
  const outOfStockItemsList = data?.outOfStockItemsList;
  const cartLocation = {
    pincode: pincode,
    lat: Number(latitude),
    lng: Number(longitude),
  };

  syncDeviceCart(deviceCartItems);
  dispatch(updateCurrentPatientId(currentPatientId));

  if (patientAddressId) {
    dispatch(updateCurrentAddressId(patientAddressId));
  } else {
    dispatch(updateCurrentAddressId(""));
  }

  dispatch(updateIsAddressUpdated(false));

  dispatch(updatePickAddressDialogOpen(false));
  if (data?.amount) {
    dispatch(
      setCartTotalAmount(data?.amount?.hcBreakdown?.effectiveAmount || 0)
    );
  }
  if (pincode) {
    dispatch(
      updateSpecifiedLocation({
        city,
        country: "",
        latitude: Number(latitude),
        longitude: Number(longitude),
        pincode,
        state,
      })
    );
  }

  cartLocation?.pincode === "" ? dispatch(setCartLocation(null)) : dispatch(setCartLocation(cartLocation));
  if (outOfStockItemsList?.length) dispatch(appendOutOfStockSkus([...outOfStockItemsList]));
};
